import { Namespace } from '_core/utils/ssr';

export const legalConfig = {
  i18nNamespaces: ['common', 'legal', 'briefing'] as Namespace,
};
